// The degen visitors: now and then a visitor at the glass is the whale, laser eyes, the influencer, the anon dev, two frens
// in a coat, the hopium balloon, cold storage, the bot farm or the rocket.
// Art only, and by seed only: degenOf never sees who is a visitor or a neighbour, so the look can't give anyone away.
// The mixed-in animals, Full fever and story mode's faces come first (game/cast.js headOf, client/visitors.js makeLook).
export const DEGENS = ['whale', 'laser', 'influencer', 'anon', 'frens', 'balloon', 'ice', 'farm', 'rocket'];

// share of regular visitors who turn up as one of them
export const DEGEN_SHARE = 0.1;

const fmix = h => { h >>>= 0; h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b); h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35); h ^= h >>> 16; return h >>> 0; };
export function degenOf(seed) {
  const h = fmix((seed ^ 0x2545f491) >>> 0);
  if (h / 4294967296 >= DEGEN_SHARE) return null;
  return DEGENS[fmix(h ^ 0x9e3779b9) % DEGENS.length];
}
